import React from 'react';
import AddIcon from '@material-ui/icons/Add';

const EventsListItemPlaceholder = () => (
    <div className="col-lg-3 col-md-6 col-sm-12">
        <div className="item placeholder">
            <div className="inner">
                <div className="top">
                    <div className="category">
                        <span className="placeholder-line"></span>
                    </div>
                    <div className="dates">
                        <span className="placeholder-line"></span>
                    </div>
                </div>
                <div className="title">
                    <span className="placeholder-line"></span>
                    <span className="placeholder-line"></span>
                </div>
                <div className="bottom">
                    <div className="line-1">
                        <span className="placeholder-line"></span>
                    </div>
                    <div className="line-2">
                        <span className="placeholder-line"></span>
                    </div>
                </div>
                <span className="btn-more">
                    <AddIcon className="m-icon" />
                </span>
            </div>
        </div>
    </div>
);

export default EventsListItemPlaceholder;


// WEBPACK FOOTER //
// ./src/features/Events/components/List/EventsListItemPlaceholder.js